import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { UserContext, authAPI } from '@mirinae/react-auth';
import { HeaderComponent } from '@mirinae/react-gnb';

import GlobalContext from '@mirinae/members/modules/contexts/globalContext';
import { membersPaths, explorerPaths, lessonsPaths, authPaths, wikinaePaths } from '@mirinae/shared/defines/paths';
import GTM from '@mirinae/shared/apis/GoogleAnalytics';
import Localization, { langsSelectList } from '@mirinae/shared/il8n';
import { getUserType, promotionSessionKey } from '@mirinae/shared/defines/datas';
import { useAppVersionStore } from '@mirinae/stores/appVersion';

const HeaderContainer = props => {
    // const location = useLocation();
    authAPI.setHistory(window.history);
    const isApp = useAppVersionStore(state => state.isApp);

    const [userContext] = useContext(UserContext);
    const [globalData, setGlobalData] = useContext(GlobalContext);
    
    const handlelogout = () => {
        authAPI.logout().then(() => {
            // clear session promo code
            if (sessionStorage.getItem(promotionSessionKey['YT-DEC2022'])) {
                sessionStorage.removeItem(promotionSessionKey['YT-DEC2022']);
            }
            // force a page-reload to induce guest-user reset
            // window.location.href = membersPaths.home;
            window.location.href = explorerPaths.home;
        });
        GTM.userAction('logout', { }, 'members');
    };

    const handleClickPrefs = (newPrefs) => {
        const updatedPrefs = ({ ...globalData.prefs, ...newPrefs });
        authAPI.updatePrefs(updatedPrefs).then(() => {
            setGlobalData(prev => ({ ...prev, ...updatedPrefs }));
            if (newPrefs.language) {
                Localization.setLanguage(newPrefs.language);
                document.querySelector('html').setAttribute('lang', newPrefs.language);
                GTM.userAction('lang-select', { language: newPrefs.language }, 'members');
                window.location.reload();
            }
        });
    };

    useEffect(() => {
        // set language value
        if (userContext.user.preferences) {
            // const prefs = _.merge(globalData.prefs, userContext.user.preferences); // this code has bug
            const prefs = ({ ...globalData.prefs, ...userContext.user.preferences });
            setGlobalData(prev => ({ ...prev, ...prefs }));
            if (prefs.language !== Localization.getLanguage()) {
                Localization.setLanguage(prefs.language);
                GTM.userAction('lang-select', { language: prefs.language }, 'members');
            }
            if (prefs.language !== document.querySelector('html').getAttribute('lang')) {
                document.querySelector('html').setAttribute('lang', prefs.language);
            }
        }
    }, [userContext.user && userContext.user.preferences]);

    // const gnbMenus = [
    //     { id: 'analyze', name: 'analyzer', link: explorerPaths.home, active: false, disabled: false },
    //     { id: 'lessons', name: 'lessons', link: lessonsPaths.home, active: false, disabled: false },
    //     { id: 'library', name: 'library', link: explorerPaths.library, active: false, disabled: false },
    //     { id: 'pro', name: 'pro', link: membersPaths.plan, active: location.pathname === membersPaths.plan, disabled: false },
    //     { id: 'profile', name: 'profile', link: membersPaths.profile, active: [membersPaths.profile, membersPaths.accountSetting, membersPaths.subscription].indexOf(location.pathname) !== -1, disabled: false },
    // ];

    const gnbLinks = {
        home: '/',
        lessons: lessonsPaths.home,
        library: explorerPaths.reference,
        wikinae: wikinaePaths.home,
        pro: membersPaths.home,
        profile: membersPaths.profile,
        login: `${authPaths.login}?redirect=${membersPaths.profile}`,
        signup: `${authPaths.signup}?redirect=${membersPaths.profile}`,
        help: explorerPaths.help,
    };
    
    if (location.pathname === authPaths.signup
        || location.pathname === authPaths.login
        || location.pathname === authPaths.emailSignup
        || location.pathname === membersPaths.payment
        || location.pathname === membersPaths.plan
        || isApp) return null;

    const pathname = window.location.pathname.replace(/\/$/, '');

    return (
        <HeaderComponent
            isApp={isApp} mode="members"
            user={userContext.user} userType={getUserType(userContext.user)}
            gnbLinks={gnbLinks}
            langsList={langsSelectList}
            prefs={globalData.prefs} onClickPrefs={handleClickPrefs}
            onLogout={handlelogout}
            localization={Localization}
        />
    );
};

export default HeaderContainer;